/**
 * Like the JS Filter, but with a tree
 * @param {*} tree
 * @param {*} filterFn
 * @returns
 */
export const filterTree = (tree = [], filterFn) => {
  const filteredNodes = tree.filter((node) => filterFn(node));
  return filteredNodes.map((node) => {
    return {
      ...node,
      children: filterTree(node.children, filterFn),
    };
  });
};
